import FormContainer from '@components/form/container'
import { Control } from 'react-hook-form'
import { FormWoiModel, WoiGeneralOptions } from '@services/model/form/form.WOI.model'
import { useTranslation } from 'react-i18next'
import FormTable from '@components/form/table'
export default ({ control }: { control: Control<FormWoiModel> }) => {
  const { t } = useTranslation()

  return (
    <FormContainer fkey={`woi-i`}>
      <FormTable
        columns={[
          {
            field: 'dateOfContractorParticularsSubmission',
            displayName: 'Date of Contractor Particulars Submission',
            type: 'date',
          },
          {
            field: 'dateOfCompletionOfEngineerValuation',
            displayName: 'Date of Completion of Engineer Valuation',
            type: 'date',
          },
          {
            field: 'attachment',
            displayName: 'Attachment',
            type: 'fileUpload',
          },
        ]}
        fieldArrayProps={{
          name: 'siteInstructionValuations',
          control,
        }}
        height={100}
        uneditable={true}
      />
    </FormContainer>
  )
}
